import React, { useState, useEffect } from 'react';
import { useTheme } from '../App';

function SplashScreen() {
  const { theme } = useTheme();
  const [loadingDots, setLoadingDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const asciiArt = `
╦═╗┌─┐┌─┐┌┬┐┌┬┐┬┌┬┐
╠╦╝├┤ ├─┤ ││ │││ │ 
╩╚═└─┘┴ ┴─┴┘─┴┘┴ ┴ 
                    
A Discrete Reddit Reader
    by Matt Batory`;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: theme.colors.background,
      color: theme.colors.foreground,
      fontFamily: 'CaskaydiaCove Nerd Font, monospace',
    }}>
      <pre style={{
        color: theme.colors.accentGreen,
        fontSize: '16px',
        lineHeight: '1.2',
        marginBottom: '40px',
        textAlign: 'center',
      }}>
        {asciiArt}
      </pre>
      
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        color: theme.colors.accentCyan,
      }}>
        <span>Initializing terminal{loadingDots}</span>
      </div>
      
      <div style={{
        marginTop: '20px',
        fontSize: '12px',
        color: theme.colors.accentOrange,
      }}>
        [■■■□□□□□□□] Loading...
      </div>
    </div>
  );
}

export default SplashScreen;